import { render, staticRenderFns } from "./DemandIndex.vue?vue&type=template&id=53914bfd"
import script from "./DemandIndex.vue?vue&type=script&lang=js"
export * from "./DemandIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports